import { StateCreator } from "zustand";
import type { MeasureWidget, ModalDeclaration, StatisticWidget, StepDescription } from "./types.ts";
import { ReactNode, RefObject } from "react";
import { MENU_ITEMS, STEPS } from "./types.ts";
import { PROPERTIES_DEFAULT, PropertySlice } from "./property-slice.ts";
import { ApiSlice } from "./api-slice.ts";
import { Config } from "../config_context.ts";

let menu_timeout : number | undefined = undefined;

export interface AppSlice {
  config?: Config
  set_config: (value: Config) => void;
  modal_counter: number;
  set_selected_menu_item: (value: string) => void;
  selected_menu_item?: string;
  add_statistic_widget: (widget: StatisticWidget) => void;
  statistic_widgets: Array<StatisticWidget>;
  add_measures_widget: (widget: MeasureWidget) => void;
  measures_widgets: Array<MeasureWidget>;
  push_modal: (modal: ModalDeclaration, ref?:RefObject<HTMLButtonElement>) => void;
  push_modal_non_close: (modal: ReactNode, ref?:RefObject<HTMLButtonElement>) => void;
  push_modal_closeable: (modal: ReactNode, ref?:RefObject<HTMLButtonElement>) => void;
  clear_modal: () => void;
  pop_modal: () => ModalDeclaration | undefined;
  modals: Array<ModalDeclaration>;
  modal_ref?:RefObject<HTMLDivElement>;
  is_modal_active: () => boolean;
  active_modal: () => ModalDeclaration;
  keep_menu_open: boolean;
  help_text?: string;
  set_help_text: (value: string) => void;
  // menu_items: Array<{
  //   id: string;
  //   label: string;
  // }>;
  open_menu: () => void;
  close_menu: () => void;
  current_step: StepDescription;
  current_step_number: number,
  last_step_number: number,
  steps: Array<StepDescription>;
  set_step: (value: number) => void;
  increment_step: () => void;
  decrement_step: () => void;

  is_last_step: () => boolean;
  is_step_id: (string: string) => boolean;
  session_token: undefined | string;
  // api_login: () => Promise<void>;
  // api_basic_data: () => Promise<void>;
  // api_calculate_energy_costs: () => Promise<void>;
  reset: () => Promise<void>;
  //open_print_view: () => Promise<void>;

}

export const createAppSlice: StateCreator<AppSlice & ApiSlice & PropertySlice, [], [], AppSlice> = (
  set,
  get,
) => ({
  // open_print_view: async (exclusive_id? : number) => {
  //     const config = get().config;        
	// 	  const antragsteller = get().antragsteller;
	//  	  const antragsteller_detail = get().antragsteller_detail;
	// 	  const _antragsteller = (antragsteller?.length == 1) ? antragsteller[0] : antragsteller_detail;
		 
	// 	 const angabedaten = {
	// 		"massnahmen" : get().getGewerkLabels().join(', '),
	// 		"antragsteller" : FDWAntragsteller[_antragsteller!],
	// 		"ort" : get().plz +" "+ get().gemeinde?.gemeinde_name,
	// 		"gebaeude" : get().gebaeude,
	// 		"typ" : get().typ  || "Neubau",
	// 		"baujahr" : get().baujahr			
	// 	 }

	// 	 const data = {
	// 		  baseurl: config?.baseurl,
	// 		  coverurl: config?.cover_url,
	// 		  logourl: config?.logo_url,
	// 		  logo2url: config?.logo2_url,
	// 		  sessionid: get().session_id,
	// 		  fpids: get().getResultIncludedInPrint()!.map(fp_entry => fp_entry.fp_id).join(','),
	// 		  gemeindeid: get().gemeinde_id,
	// 		  gewerk: Object.keys(get().gewerk_code).map( key => ''+key+'--'+get().gewerk_code[parseInt(key)].join(',')).join(';'),
	// 		  typ: get().typ  || "Neubau",
	// 		  wohngebaeude: get().wohngebaeude  || false,
	// 		  gewerbegebaeude: get().gewerbegebaeude  || false,
	// 		  gemeinnuetzig: get().gemeinnuetzig || false,
	// 		  gebaeude: get().gebaeude,
	// 		  baujahr: get().baujahr,
	// 		  grundversorger: get().grundversorger || '',
	// 		  antragsteller: get().antragsteller,
	// 		  evu1id: get().evu1_id  || '',
	// 		  evu2id: get().evu2_id  || '',
	// 		  lang: get().lang  || 'de',
	// 		  nutzer: get().nutzer || '',
	// 		  inprint: exclusive_id ? exclusive_id : Object.keys(get().include_in_print).filter(key => get().include_in_print[key]).join(','),
	// 		  angabedaten: JSON.stringify(angabedaten)			  
	// 		};
			      			
	// 	  const windowOptions = 'toolbar=0,location=0,menubar=0';
	// 	  const newWindow = window.open('','questionizer', windowOptions);

	// 	  if (newWindow) {
  //       const form = document.createElement('form');
  //       form.method = 'POST';
  //       form.action = config?.baseurl+"/print-view.php";
  //       form.target = 'questionizer'; 
        
  //       for (const key in data) {
  //         if (data.hasOwnProperty(key)) {
  //           const input = document.createElement('input');
  //           input.type = 'hidden';
  //           input.name = key;
  //           input.value = data[key as keyof typeof data] as string;
  //           form.appendChild(input);
  //         }
  //       }

  //       console.log(form);
  //       document.body.appendChild(form);
  //       setTimeout(() => {
	// 			  form.submit(); // Sende das Formular
	// 			  document.body.removeChild(form); // Entferne das Formular nach dem Senden
	// 			}, 100); // Ein kurzes Timeout, um sicherzustellen, dass das Fenster geöffnet ist
	// 	  } else {
	// 		  console.error('Das neue Fenster konnte nicht geöffnet werden. Popup-Blocker aktiv?');
	// 	  }
  // },

  set_config: (value) => {
    set((_state) => ({ config: value  }));
  },

  modal_counter:0,
  set_selected_menu_item: (value) => {
    clearTimeout(menu_timeout);
    menu_timeout = setTimeout(()=>{
      if(get().modals.length == 0){
          set((_state) => ({ keep_menu_open: false }));
      }
    }, 500);    
    set((_state) => ({ selected_menu_item: value, keep_menu_open: true  }));
  },
  selected_menu_item: undefined,
  add_statistic_widget: (widget) => {
    if (!get().statistic_widgets.some((w) => widget.key == w.key)) {
      set((state) => ({
        statistic_widgets: [...state.statistic_widgets, widget],
      }));
    }
  },
  statistic_widgets: [],
  add_measures_widget: (widget) => {
    if (!get().measures_widgets.some((w) => widget.key == w.key)) {
      set((state) => ({
        measures_widgets: [...state.measures_widgets, widget],
      }));
    }
  },
  measures_widgets: [],

  clear_properties_changed: () => {
    set((_) => ({ properties_changed: [] }));
  },

  push_modal: (modal, ref) => {
    set((state) => ({ modal_ref: ref, modal_counter: get().modal_counter + 1, modals: [...state.modals, modal] }));
  },
  push_modal_non_close: (modal, ref) => {
    set((state) => ({ modal_ref: ref, modal_counter: get().modal_counter + 1, modals: [...state.modals, {modal_ref: ref, close_on_click_background: false, modal: () => modal}] }));
  },
  push_modal_closeable: (modal, ref) => {
    set((state) => ({ modal_ref: ref, modal_counter: get().modal_counter + 1, modals: [...state.modals, {modal_ref: ref, close_on_click_background: true, modal: () => modal}] }));
  },
  pop_modal: () => {
    const modals = [...get().modals];
    if(modals.length == 0){
      clearInterval(menu_timeout);
      menu_timeout = setTimeout(()=>{
        if(get().modals.length == 0){
            set((_state) => ({ keep_menu_open: false }));
        }
      }, 500); 
    }
    const popped = modals.pop();
    set((_state) => ({ modal_counter: get().modal_counter + 1, modals }));
    
    const modal_ref = popped?.modal_ref?.current;
    //console.log("-->", modal_ref,"---------------", get().modal_ref?.current);
    if(modal_ref){
      console.log("JUMP BACK,A");
      //modal_ref.focus();
      setTimeout(()=>{
        console.log("JUMP BACK");
        modal_ref.focus();
      }, 10); 
    }

    return popped;
  },
  is_modal_active: () => {
    return get().modals.length > 0;
  },
  active_modal: () => {
    return get().modals[get().modals.length - 1];
  },
  clear_modal: () => {
    clearInterval(menu_timeout);
    menu_timeout = setTimeout(()=>{
      if(get().modals.length == 0){
          set((_state) => ({ keep_menu_open: false }));
      }
    }, 500);   
    set((_state) => ({ modals: [] }));
  },
  modals: [],
  keep_menu_open: false,
  close_menu: () => {
    set((_state) => ({ selected_menu_item: undefined, keep_menu_open: false }));
  },
  open_menu: () => {
    set((_state) => ({ selected_menu_item: MENU_ITEMS[0].id}));
  },
  set_help_text: (value) => {
    set((_state) => ({ help_text: value}));
  },

  current_step: STEPS[0],
  current_step_number: 0,
  last_step_number: 0,
  steps: STEPS,
  set_step: (value: number) => {
    try{
      window.dataLayer.push({
        'event': 'page_change',
        'event_category': 'navigation',
        'event_action': 'page_change',
        value: value,
      });
    }catch(_e) {
        console.warn("datalayer not initialized");
    }
        
    set((state) => ({ last_step_number:state.current_step_number, current_step_number: value, current_step: STEPS[value]}));
  },
  increment_step: () => {
    get().set_step(Math.min(get().current_step_number + 1,get().steps.length -1));
  },
  decrement_step: () => {
    get().set_step(Math.max(get().current_step_number - 1,0));
  },
  is_last_step: ()=>{
    return get().current_step_number == get().steps.length - 1;
  },
  is_step_id: (string: string) => {
    return get().current_step.id == string;
  },

  reset: async () => {
    set((_)=>({...PROPERTIES_DEFAULT, last_step_number:0, current_step_number: 0, current_step: STEPS[0]}));
    await get().api_login();
  }
});
